import { StateCreator } from 'zustand';

import {
  DelegationComposerEntry,
  DelegationComposerState,
  DelegationComposerStore,
} from './types';

export const EMPTY_DELEGATION_COMPOSER_ENTRY: DelegationComposerEntry = {
  draft: '',
  queuedMessage: null,
  lastSentMessage: null,
  pendingMessage: null,
  hasSendFailed: false,
};

export const INITIAL_DELEGATION_COMPOSER_STATE: DelegationComposerState = {
  stateByEntry: {},
};

function patchEntry(
  state: DelegationComposerState,
  entryId: string,
  patch: Partial<DelegationComposerEntry>,
): DelegationComposerState {
  const current =
    state.stateByEntry[entryId] ?? EMPTY_DELEGATION_COMPOSER_ENTRY;
  return {
    stateByEntry: {
      ...state.stateByEntry,
      [entryId]: { ...current, ...patch },
    },
  };
}

export const createDelegationComposerSlice: StateCreator<
  DelegationComposerStore
> = (set) => ({
  ...INITIAL_DELEGATION_COMPOSER_STATE,
  setDraft: (entryId, draft) =>
    set((state) => patchEntry(state, entryId, { draft })),
  setQueuedMessage: (entryId, text) =>
    set((state) => patchEntry(state, entryId, { queuedMessage: text })),
  clearQueuedMessage: (entryId) =>
    set((state) => patchEntry(state, entryId, { queuedMessage: null })),
  setPendingMessage: (entryId, text) =>
    set((state) => patchEntry(state, entryId, { pendingMessage: text })),
  clearPendingMessage: (entryId) =>
    set((state) => patchEntry(state, entryId, { pendingMessage: null })),
  setSendFailed: (entryId, hasSendFailed) =>
    set((state) => patchEntry(state, entryId, { hasSendFailed })),
  recordSentMessage: (entryId, text) =>
    set((state) => patchEntry(state, entryId, { lastSentMessage: text })),
  resetState: () => set(INITIAL_DELEGATION_COMPOSER_STATE),
});
